import React, { useRef } from "react";
import { Carousel } from "antd";

import AppContainer from "../../components/AppContainer/AppContainer";
import FormSectionContainer from "../../components/FormSectionContainer/FormSectionContainer";

import TourOperatorFormContext from "../../features/touroperator/context-form";
import TourOperatorNonPH from "../../features/touroperator/NonPHResidentSection";
import TourOperatorPHResident from "../../features/touroperator/PHResidentSection";
import CarouselButtons from "../../components/CarouselButtons/CarouselButtons";

const sections = [
  {
    index: 1,
    title: "Local Tourist",
    headerColor: "RGB(135, 175, 221)",
    children: <TourOperatorPHResident />,
  },
  {
    index: 2,
    title: "Foreign Tourist",
    headerColor: "RGB(209, 194, 138)",
    children: <TourOperatorNonPH />,
  },
];

const TourOperatorFormPage = () => {
  const carouselRef = useRef();
  return (
    <AppContainer title="Tour Operator Report">
      <TourOperatorFormContext>
        <Carousel ref={carouselRef} infinite={false}>
          {sections.map((props, index) => (
            <>
              <FormSectionContainer key={index} {...props} />
              <CarouselButtons carouselRef={carouselRef} />
            </>
          ))}
        </Carousel>
      </TourOperatorFormContext>
    </AppContainer>
  );
};

export default TourOperatorFormPage;
